import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export default function Logout() {
  const { logout, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    // returnTo is passed explicitly rather than left to the Auth0 tenant's
    // default logout URL. With more than one host on the same tenant, the
    // default sends a user logging out of test over to production.
    if (isAuthenticated && !isLoading)
      logout({ returnTo: process.env.REACT_APP_AUTH0_LOGOUT_URL });
    else if (!isLoading) {
      navigate("/");
    }
  }, [isAuthenticated, isLoading]);

  return <div>Logging Out...</div>;
}
